import {Observable} from 'rxjs';
import {Component, effect, inject} from '@angular/core';

import {KEYCLOAK_EVENT_SIGNAL, KeycloakEventType, ReadyArgs, typeEventArgs} from 'keycloak-angular';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {MatListModule} from '@angular/material/list';
import {Router} from "@angular/router";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatButtonModule} from "@angular/material/button";
import Keycloak, {KeycloakProfile} from "keycloak-js";
import {jwtDecode} from "jwt-decode";

@Component({
  selector: 'app-header',
  imports: [MatToolbarModule, MatIconModule, MatMenuModule, MatListModule, CommonModule, MatTooltipModule, MatButtonModule, NgOptimizedImage],
  templateUrl: './navigation.component.html',
  standalone: true,
  styleUrls: ['./navigation.component.sass'
  ]
})
export class NavigationComponent {
  mobileQuery: MediaQueryList;
  isLoggedIn$: Observable<boolean>;
  userDetails: KeycloakProfile;
  claims: any;
  authenticated = false;
  keycloakStatus: string | undefined;
  private readonly keycloak = inject(Keycloak);
  private readonly keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);

  constructor(public snackBar: MatSnackBar, protected readonly router: Router) {
    effect(() => {
      const keycloakEvent = this.keycloakSignal();

      this.keycloakStatus = keycloakEvent.type;

      if (keycloakEvent.type === KeycloakEventType.Ready) {
        this.authenticated = typeEventArgs<ReadyArgs>(keycloakEvent.args);
      }

      if (keycloakEvent.type === KeycloakEventType.AuthLogout) {
        this.authenticated = false;
      }
    });
  }

  async ngOnInit() {
    if (this.keycloak.authenticated && this.keycloak.token) {
      this.userDetails = await this.keycloak.loadUserProfile();
      this.claims = jwtDecode<any>(this.keycloak.token);
      localStorage.setItem("userDetails", JSON.stringify({
        "details": this.userDetails,
        "claims": this.claims
      }));
      console.log(JSON.stringify({
        "details": this.userDetails,
        "claims": this.claims
      }));
      this.openSnackBar('Bienvenido ' + this.userDetails.firstName + ' ' + this.userDetails.lastName, 'Cerrar');
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
      panelClass: ['my-snack-bar']
    });
  }

  async doLogout() {
    await this.keycloak.logout();
  }

  async doLogin() {
    await this.keycloak.login();
  }

  goToApplications() {
    this.router.navigate(['home']);
  }
}
